"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = require("./Button");
var StyledButtongroup = _styledComponents["default"].div.withConfig({
  displayName: "ButtonGroup__StyledButtongroup",
  componentId: "sc-10w8dzt-0"
})(["display:inline-flex;flex-direction:row;> ", ":focus,> ", ":hover,> ", ":active{z-index:1;}> ", "{border-radius:0rem;}> ", ":first-child{border-bottom-left-radius:0.5rem;border-top-left-radius:0.5rem;}> ", ":last-child{border-bottom-right-radius:0.5rem;border-top-right-radius:0.5rem;}"], _Button.StyledButton, _Button.StyledButton, _Button.StyledButton, _Button.StyledButton, _Button.StyledButton, _Button.StyledButton);
var _default = exports["default"] = StyledButtongroup;
//# sourceMappingURL=ButtonGroup.js.map